var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2465.929565c.1704 0 .3408.083105.426.166205s.1705.2493.0853.58169L43.9183 50.9549c-.0852.3324-.3408.4986-.5964.4986H32.926l-.6816 7.9775h4.3458l-10.055 9.8056-10.0549-9.8056h4.3458l-.6818-8.0606H9.91898c-.34084 0-.51122-.2493-.59643-.4986L.971802 1.59436c-.085211-.1662.000083-.33239.085298-.49859.08521-.0831.25563-.166205.42605-.166205H51.2465ZM48.2641 11.4831c-1.3634-.5817-3.0676-.3324-4.6867.2493-6.1352 2.4098-10.3957 3.3239-16.8717 1.3296-.9993-.3046-1.9834-.6885-2.9658-1.0718-3.0387-1.1855-6.0623-2.36503-9.4751-1.1719-2.9824 1.0803-5.79437 2.0775-9.20282 1.9944l-1.9599-9.80567H49.6275l-1.3634 8.47607ZM26.5352 42.562c3.6641.2493 5.9648-1.9944 5.9648-1.9944 3.6641-3.6563 2.386-8.1437.9374-10.4704-.7669-1.4127-6.4761-9.8057-6.9874-10.5536-.1044.1629-.5309.7895-1.1267 1.6648-1.8365 2.6981-5.2816 7.7594-5.8606 8.8888-1.2782 2.3267-2.6416 6.8141 1.1077 10.4704 0 0 2.3007 2.2437 5.9648 1.9944Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal6);
export default __webpack_public_path__ + "static/media/goal-6.8800304b80d79f73ab9cfe7c4a1cbfa9.svg";
export { ForwardRef as ReactComponent };